<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Configurazione Reparti
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_nuova_sede = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-view-grid-plus-outline </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Sede</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_nuovo_reparto = true"
            small
            v-bind="attrs"
            v-on="on"
            class="ml-5"
          >
            <v-icon color="primary"> mdi-store-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Reparto</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-dialog v-model="apri_dettaglio" persistent>
        <DettaglioReparto
          @click_chiudi_dettaglio="
            apri_dettaglio = false;
            reparto_selez = '';
          "
          @salvataggio_reparto="getReparti()"
          :reparto="reparto_selez"
          :key="nuovo_mounted"
        />
      </v-dialog>
      <v-data-table
        :headers="headers_reparti"
        :items="reparti_lista"
        fixed-header
      >
        <!-- Colonna del modifica -->
        <template v-slot:[`item.modifica`]="{ item }">
          <v-btn
            @click="
              reparto_selez = item;
              apri_dettaglio = true;
              nuovo_mounted = nuovo_mounted == 1 ? 0 : 1;
            "
            small
            ><v-icon color="primary">mdi-pencil</v-icon></v-btn
          >
        </template>
        <!-- Colonna del delete -->
        <template v-slot:[`item.delete`]="{ item }">
          <v-btn
            @click="
              dialog_conferma_elimina = true;
              id_eliminazione = item.id_azienda_sede_reparto;
            "
            small
            v-model="item.cancellato"
            ><v-icon color="error">mdi-close</v-icon></v-btn
          >
        </template>
      </v-data-table>
    </v-card-text>
    <!-- DIALOG NUOVO REPARTO -->
    <v-dialog v-model="dialog_nuovo_reparto" max-width="600px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Nuovo reparto</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaNuovoReparto" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dialog_nuovo_reparto = false;
                  sede_nuovo_rep = null;
                  nome_nuovo_rep = '';
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <v-row>
            <v-col cols="6">
              <v-text-field
                class="ml-5"
                v-model="nome_nuovo_rep"
                type="text"
                label="Nome reparto"
              />
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                :items="lista_sedi"
                label="Sede"
                item-text="descrizione"
                return-object
                v-model="sede_nuovo_rep"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG NUOVA SEDE-->
    <v-dialog v-model="dialog_nuova_sede" max-width="600px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Nuova sede</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaNuovaSede" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dialog_nuova_sede = false;
                  sede_nome_nuovo = '';
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-text-field
                class="ml-5"
                v-model="sede_nome_nuovo"
                type="text"
                label="Nome sede"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="12">
              <v-data-table
                height="60vh"
                style="width: 40vw; margin: auto"
                :headers="headers_sedi"
                :items="lista_sedi"
                fixed-header
                class="elevation-1 pt-0"
              >
                <template v-slot:[`item.modifica`]="{ item }">
                  <v-btn
                    @click="editSede(item)"
                    small
                    ><v-icon color="primary">mdi-pencil</v-icon></v-btn
                  >
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                  <v-btn
                    @click="eliminaSede(item.id_azienda_sede, item.id_azienda)"
                    small
                    ><v-icon color="error">mdi-close</v-icon></v-btn
                  >
                </template>
              </v-data-table>
            </v-col></v-row
          >
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_edit_sede" width="40vw">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Modifica sede</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaEditSede" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dialog_edit_sede = false;
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
            <v-text-field label="Nome" v-model="edit_sede.descrizione"></v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG CONFERMA ELIMINAZIONE -->
    <v-dialog v-model="dialog_conferma_elimina" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Eliminazione</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di conferma -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  rimuoviReparto(id_eliminazione);
                  dialog_conferma_elimina = false;
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_elimina = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h2 class="mt-5">Clicca salva per rimuovere il reparto.</h2>
        </v-card-text>
      </v-card>
    </v-dialog>
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import DettaglioReparto from "@/components/PRODUCTION/Impostazioni/DettaglioReparto.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",

  components: {
    DettaglioReparto,
    SnackbarQV,
  },

  props: {},

  data() {
    return {
      // Variabili d'appoggio
      reparto_selez: "",
      id_eliminazione: "",
      nome_nuovo_rep: "",
      sede_nuovo_rep: null,
      sede_nome_nuovo: "",
      nuovo_mounted: 0,

      // Modal
      dialog_nuovo_reparto: false,
      apri_dettaglio: false,
      dialog_conferma_elimina: false,
      dialog_nuova_sede: false,
      dialog_edit_sede: false,

      // Array
      reparti_lista: new Array(),
      headers_reparti: new Array(),
      lista_sedi: new Array(),
      headers_sedi: new Array(),
      edit_sede: {},
    };
  },

  computed: {},

  watch: {
    variabile: {
      immediate: true,

      handler() {},
    },
  },

  methods: {
    eliminaSede(id_sede, id_azienda) {
      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.user_token,
          action: "saveaziendasede",
          sede: [{
            id_azienda: id_azienda,
            id_azienda_sede: id_sede,
            validita: 0,
          }],
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status == 200 || res.status == 204) {
          this.getSedi();
          return;
        }
      });
    },

    getReparti() {
      this.headers_reparti = [
        {
          text: "Modifica",
          sortable: false,
          value: "modifica",
          class: "",
        },
        {
          text: "Nome",
          value: "descrizione",
        },
        {
          value: "delete",
          text: "Rimuovi",
          sortable: false,
        },
      ];

      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziendasedereparti",
          id_azienda: 1,
          id_azienda_sede: null,
          id_azienda_sede_reparto: null,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.caricamento_dati = false;
        this.reparti_lista = res.data.result;
      });
    },

    getSedi() {
      this.headers_sedi = [
        {
          text: "Modifica",
          value: "modifica",
        },
        {
          text: "Nome",
          value: "descrizione",
        },
        {
          text: "Elimina",
          value: "delete",
        },
      ];

      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziendasedi",
          id_azienda: 1,
          id_azienda_sede: null,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_sedi = res.data.result ? res.data.result : [];
            console.log(this.lista_sedi);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    clickChiudi() {
      this.$emit("click_chiudi");
    },

    salvaNuovoReparto() {
      if (this.sede_nuovo_rep == null || this.nome_nuovo_rep == "") {
        this.$refs.SnackbarQV.print("error", "Campo mancante.");
      } else {
        let request = {
          controller: "schedulatore",
          method: "POST",
          richiesta: {
            token: localStorage.user_token,
            action: "saveaziendasedereparto",
            reparto: [{
              id_azienda_sede_reparto: null,
              id_azienda_sede: this.sede_nuovo_rep.id_azienda_sede,
              descrizione: this.nome_nuovo_rep,
              validita: 1,
            }],
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          if (res.status == 200) {
            this.sede_nuovo_rep = null;
            this.nome_nuovo_rep = "";
            this.dialog_nuovo_reparto = false;
            this.getReparti();
            return;
          }
        });
      }
    },

    salvaNuovaSede() {
      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.user_token,
          action: "saveaziendasede",
          sede: [{
            id_azienda_sede: null,
            id_azienda: 1,
            descrizione: this.sede_nome_nuovo,
            validita: 1
          }],
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status == 200 || res.status == 204) {
          this.sede_nome_nuovo = "";
          this.dialog_nuova_sede = false;
          this.getSedi();
          return;
        }
      });
    },

    editSede(arg){
        this.edit_sede = arg;
        this.dialog_edit_sede = true;
    },

    salvaEditSede() {
      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.user_token,
          action: "saveaziendasede",
          sede: [this.edit_sede],
          validita: 1
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status == 200 || res.status == 204) {
          this.sede_nome_nuovo = "";
          this.dialog_edit_sede = false;
          this.getSedi();
          return;
        }
      });
    },

    rimuoviReparto(id_elim) {
      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.user_token,
          action: "saveaziendasedereparto",
          reparto: [{
            id_azienda_sede_reparto: id_elim,
            validita: 0,
          }],
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        console.log(res);
        this.getReparti();
        return;
      });
    },
  },

  created() {},

  mounted() {
    this.getReparti();
    this.getSedi();
  },
};
</script>

<style scoped>
</style>